export default __webpack_public_path__ + "static/media/allow-mic.c8808dba.svg";